"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
function LoadingCards(t0) {
  const $ = _c(4);
  const {
    arr
  } = t0;
  let t1;
  if ($[0] !== arr.length) {
    t1 = new Array(arr.length !== 0 ? arr.length : 4).fill(undefined).map(_temp);
    $[0] = arr.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(res, index) {
  return <div key={index} className="bg-white rounded-lg p-4 flex-col  font-bold relative text-center w-full flex"><div className="flex gap-12"><div className="text-event bg-grey animate-pulse flex flex-col w-[71px] h-20 rounded-lg" style={{
        animationDelay: `${Math.round(Math.random() * 1500)}ms`
      }} /><div className="flex flex-col self-end"><p className="flex h-4 bg-grey w-40 rounded-lg   animate-pulse relative items-center self-end text-sm gap-3" style={{
          animationDelay: `${Math.round(Math.random() * 1500)}ms`
        }}><label className="bg-event absolute -left-6 h-3.5 inline-block aspect-square rounded-full" />{" "}</p><p className="flex h-4 bg-grey w-20 rounded-lg  mt-2 animate-pulse relative items-center self-start text-sm gap-3" style={{
          animationDelay: `${Math.round(Math.random() * 1500)}ms`
        }} /></div></div></div>;
}
export default LoadingCards;